import { ProductVisibility } from "@coaching-culture/types";
import { useAllProductVisibility } from "hooks/useProductVisibility";
import { Redirect, Route, Switch } from "react-router";
import { AssessmentsReport } from "./AssessmentsReport";
import { EngagementInsights } from "./EngagementReport";
import { LearncastReport } from "./LearncastReport";
import LessonsReport from "./LessonsReport";
import { ManagerReport } from "./ManagerReport";
import { MindsetReport } from "./MindsetReport";
import OrgInsights from "./OrgInsights";
import { PerformanceInsights } from "./PerformanceInsights";

const Insights = () => {
  const products = useAllProductVisibility();

  const hasLessons = products.lessons === ProductVisibility.Enabled;
  const hasMindset = products.mindset === ProductVisibility.Enabled;
  const hasAssessments = products.assessments === ProductVisibility.Enabled;
  const hasPerformnace = products.performance === ProductVisibility.Enabled;
  const hasLearnCast = products.learncast === ProductVisibility.Enabled;

  return (
    <Switch>
      <Route path="/success/insights" exact component={OrgInsights} />
      {hasLessons && (
        <Route
          path="/success/insights/lessons"
          exact
          component={LessonsReport}
        />
      )}
      {hasMindset && (
        <Route
          path="/success/insights/mindset"
          exact
          component={MindsetReport}
        />
      )}
      {hasAssessments && (
        <Route
          path="/success/insights/assessments"
          exact
          component={AssessmentsReport}
        />
      )}
      {hasLearnCast && (
        <Route
          path="/success/insights/learncast"
          exact
          component={LearncastReport}
        />
      )}
      {hasPerformnace && (
        <Route
          path="/success/insights/performance"
          exact
          component={PerformanceInsights}
        />
      )}
      <Route
        path="/success/insights/engagement"
        exact
        component={EngagementInsights}
      />
      <Route
        path="/success/insights/managers"
        exact
        component={ManagerReport}
      />
      <Redirect to="/success/insights" />
    </Switch>
  );
};

export default Insights;
